import React from "react";
import { Phone, MessageCircle, Instagram, Globe, MapPin } from "lucide-react";
import { Logo } from "./Navbar";

const Footer = () => {
  return (
    <footer className="bg-black border-t-2 border-red-600/50 py-12 px-6" data-testid="main-footer">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Logo size="md" />
          <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-xs">
            Türkische Spezialitäten — Döner, Lahmacun, Pizza & Salat. Frisch zubereitet, seit Jahren.
          </p>
        </div>

        <div>
          <h4 className="display text-red-500 text-xl mb-4">Kontakt</h4>
          <ul className="space-y-2 text-white/80 text-sm">
            <li className="flex items-center gap-2"><MapPin size={16} className="text-red-500"/>Schloßstraße 77, 70176 Stuttgart</li>
            <li className="flex items-center gap-2"><Phone size={16} className="text-red-500"/>0711 75486846</li>
            <li className="flex items-center gap-2"><MessageCircle size={16} className="text-red-500"/>0163 2147958</li>
            <li className="flex items-center gap-2"><Globe size={16} className="text-red-500"/>www.bydoner.de</li>
            <li className="flex items-center gap-2"><Instagram size={16} className="text-red-500"/>@bydoner_stuttgart</li>
          </ul>
        </div>

        <div>
          <h4 className="display text-red-500 text-xl mb-4">Öffnungszeiten</h4>
          <ul className="space-y-2 text-white/80 text-sm">
            <li>Montag – Freitag: <span className="text-white">11:00 – 22:00</span></li>
            <li>Samstag – Sonntag: <span className="text-white">12:00 – 22:00</span></li>
            <li className="text-white/50 text-xs mt-4">Auch an Feiertagen geöffnet</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-white/10 text-center text-white/40 text-xs">
        © {new Date().getFullYear()} BY Döner Stuttgart. Alle Rechte vorbehalten.
      </div>
    </footer>
  );
};

export default Footer;
